import { combineReducers } from 'redux';

import appStorageFilterReducer from './appStorageFilterReducer';
import appStorageGroupsReducer from './appStorageGroupsReducer';
import appStorageSettingsReducer from './appStorageSettingsReducer';
import appStorageUploadReducer from './appStorageUploadReducer';
import appStorageVersionsReducer from './appStorageVersionsReducer';
import biometricsAuthenticationReducer from './biometricsAuthenticationReducer';
import imageInjectionReducer from './imageInjectionReducer';
import desktopSessionReducer from './desktopSessionReducer';
import desktopSessionLoadingReducer from './desktopSessionLoadingReducer';
import devicesReducer from './devicesReducer';
import rdcErrorReducer from './rdcErrorReducer';
import loadingReducer from './loadingReducer';
import metadataReducer from './metadataReducer';
import mobileDevToolsReducer from './mobileDevToolsReducer';
import mobileDrawerReducer from './mobileDrawerReducer';
import mobileLogReducer from './mobileLogReducer';
import mobileVitalsReducer from './mobileVitalsReducer';
import mobileSelectionReducer from './mobileSelectionReducer';
import mobileSessionReducer from './mobileSessionReducer';
import rdcDevicePickerReducer from './rdcDevicePickerReducer';

const manualReducer = combineReducers({
  appStorage: combineReducers({
    filters: appStorageFilterReducer,
    groups: appStorageGroupsReducer,
    settings: appStorageSettingsReducer,
    uploads: appStorageUploadReducer,
    versions: appStorageVersionsReducer,
  }),
  biometricsAuthentication: biometricsAuthenticationReducer,
  desktopSession: desktopSessionReducer,
  desktopSessionLoading: desktopSessionLoadingReducer,
  devices: devicesReducer,
  devTools: mobileDevToolsReducer,
  drawer: mobileDrawerReducer,
  imageInjection: imageInjectionReducer,
  loading: loadingReducer,
  log: mobileLogReducer,
  metadata: metadataReducer,
  mobileSelection: mobileSelectionReducer,
  rdcError: rdcErrorReducer,
  rdcDevicePicker: rdcDevicePickerReducer,
  session: mobileSessionReducer,
  vitals: mobileVitalsReducer,
});

export default manualReducer;
